let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3cJmB")).then(() => parcelRequire('9PlAg'));